export const formBuilderAdapter = {
  array: (config: any) => config,
  control: (config: any) => config,
  group: (config: any) => config,
};
